module.exports = __webpack_public_path__ + "img/pmsm2_.04f43d85.png";